/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { FormattedRelative } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './District.css';
import { connect } from 'react-redux';

import MapControl from '../../components/MapControl';

import {
  fetchSectors,
  fetchGraveyard,
  fetchZarzad,
  fetchGraves,
  fetDistrictCompositions,
  fetchDistrictParcels,
} from '../../actions/district';

class District extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  componentDidMount() {
    if (this.props.district.prefix === 'swiebodzice') {
      this.props.fetchSectors('219021');
      this.props.fetchGraves('219021');
      this.props.fetchGraveyard('219021');
      this.props.fetchZarzad('219021');
    }
    if (this.props.district.prefix === 'gmina_zarow') {
      this.props.fetchSectors('219083');
      this.props.fetchGraves('219083');
      this.props.fetchGraveyard('219083');
      this.props.fetchZarzad('219083');
    }
    if (this.props.district.prefix === 'gmina_siekierczyn') {
      this.props.fetchSectors('210072');
      this.props.fetchGraves('210072');
      this.props.fetchGraveyard('210072');
      this.props.fetchZarzad('210072');
    }
    if (this.props.district.prefix === 'gmina_strzegom') {
      this.props.fetchSectors('219063');
      this.props.fetchGraves('219063');
      this.props.fetchGraveyard('219063');
      this.props.fetchZarzad('219063');
    }
    if (this.props.district.prefix === 'gmina_swierzawa') {
      this.props.fetchSectors('226043');
      this.props.fetchGraves('226043');
      this.props.fetchGraveyard('226043');
      this.props.fetchZarzad('226043');
    }
    if (this.props.district.prefix === 'jawor') {
      this.props.fetchSectors('205011');
      this.props.fetchGraves('205011');
      this.props.fetchGraveyard('205011');
      this.props.fetchZarzad('205011');
    }
    this.props.fetDistrictCompositions();
    this.props.fetchDistrictParcels();
  }

  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.mymap}>{this.props.district ? <MapControl /> : null}</div>
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  district: state.district.district,
});
const mapDispatch = {
  fetchSectors,
  fetchGraveyard,
  fetchGraves,
  fetDistrictCompositions,
  fetchDistrictParcels,
  fetchZarzad
};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(District),
);



// WEBPACK FOOTER //
// src/routes/district/District.js